import RedeemablePerk from './RedeemablePerk.mjs';

export default function PerkSection({ section, onSelect, curTokens, curScore, onQtyChange, perkIndex, perkProps, updateIndex, ...props } = props) {
	let disclaimers = [];
	const renderDisclaimers = () => {
		return disclaimers.map((disclaimer, index) => (
			<div key={index} className='text-muted small'>
				<sup>*</sup>
				{disclaimer}
			</div>
		));
	};

	return (
		<div className='perk-block rounded p-2 pt-3 p-md-4 mb-1'>
			<div className='vstack gap-4'>
				<div>
					<mark className='px-2 rounded-1 fw-bold text-uppercase'>
						{section.required.tokens} Prime Token{section.required.tokens === 0 || section.required.tokens > 1 ? 's' : false} {section.required.wscore && section.required.wscore > 0 ? ` & ${section.required.wscore.toLocaleString()} WScore` : false} required
					</mark>
				</div>
				<div className='vstack gap-1'>
					{section.perks.map((perk, i) => {
						perk.disclaimer && disclaimers.push(perk.disclaimer);
						return <RedeemablePerk key={i} perk={perk} curPerkIndex={perkIndex} perkProps={perkProps} onSelect={onSelect} onQtyChange={onQtyChange} curTokens={curTokens} curScore={curScore} updateIndex={updateIndex} />;
					})}
				</div>
        {disclaimers.length > 0 && (
          <div>{renderDisclaimers()}</div>
        )}
			</div>
		</div>
	);
}
